<template>
    <div class="flex justify-center items-center">
        <div class="w-full max-w-sm px-2">

            <h1 class="text-center text-azuloscuro text-xl font-semibold mt-10 mb-5">
                Pills diarias
            </h1>

            <div class="w-full mb-10 self-center px-8">
                <img src="@/assets/images/Onboarding2.png"
                class="w-full mb-10 self-center" />
            </div>

            <div>
                <p class="text-center text-azuloscuro text-md mx-8">
                    En la HOME, encontrarás las nuevas Pills pendientes, así como el histórico de las que ya has completado.
                </p>
            </div>
            <div class="text-center mt-5" style="margin-bottom: 132px">
                <span class="ball"></span><span class="ball filled"></span><span class="ball"></span>
            </div>

            <div class="fixed inset-x bottom-0 left-0 px-4 pb-6 w-full bg-white">
                <div class="mt-5">
                    <router-link
                    to="/tutorial-step-3"
                    class="">
                        <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                        type="button">
                            Siguiente
                        </button>
                    </router-link>
                </div>

                <div class="mt-5 text-center">
                    <router-link
                        to="/"
                        class="inline-block self-center text-sm text-blue-500 hover:text-blue-800">
                        Saltar
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'
    import setTitle from "../plugins/title";

    const TutorialStep2 = {
        name: 'TutorialStep2',
        layout: '',
        data: function(){
            return {

            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }
        },
        methods: {

        },
        created () {
            setTitle('Tutorial 2/3')
        }
    }

    export default TutorialStep2;
</script>

<style>
    .ball {
        display: inline-block;
        background: gray;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        margin: 0 6px;
        background: #E9ECFF;
    }

    .filled {
        background: #170E47;
    }
</style>
